import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ds-info-unavailable',
  templateUrl: './order-info-unavailable.component.html',
  styleUrls: ['./order-info-unavailable.component.scss']
})
export class OrderInfoUnavailableComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  @Input() orderUnavailableHeader: string = '';
  @Input() orderUnavailableBody: string = '';

  ngOnInit(): void {
    if (this.orderUnavailableHeader === '') {
      this.orderUnavailableHeader = this.translate.instant(`GENERIC.COMMON_PAGES.ORDER_UNAVAILABLE_HEADER`);
    }
    if (this.orderUnavailableBody === '') {
      this.orderUnavailableBody = `${this.translate.instant(`GENERIC.COMMON_PAGES.ORDER_UNAVAILABLE_BODY_TEXT`)} ${this.translate.instant(`GENERIC.COMMON_PAGES.CHECK_BACK_SOON`)}`;;
    }
  }

}
